//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import StockMovementListView from '@/views/Warehouse/WhStockMovement/list'

/**
 *
 */
export default {
    path: 'stock_movements',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'stock-movement-list',
            component: StockMovementListView,
        },
    ],
    meta: {
        title: 'Movimientos de inventario',
    },
}
